/* turbolinks */
const Turbolinks = require("turbolinks")
Turbolinks.start()

document.addEventListener("turbolinks:click", function() {
    const preloader = document.getElementById('loader');
    const spin = document.getElementById('spin');
    if (preloader.classList.contains('done')) {
        preloader.classList.remove('done');
        spin.classList.remove('done');
    }
})

document.addEventListener("turbolinks:load", function() {
    setTimeout(() => {
        const preloader = document.getElementById('loader');
        const spin = document.getElementById('spin');
        if (!preloader.classList.contains('done')) {
            preloader.classList.add('done');
            setTimeout(() => {
                spin.classList.add('done');
            }, 700)
        }
    }, 100)
})
/* end of turbolinks */
